import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initSentry, Sentry } from './lib/sentry';
import './styles.css';

// Wire Sentry before React mounts so the global error/unhandledrejection
// listeners catch any failures during the very first render pass.
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/*
      ErrorBoundary keeps a render-time crash inside one branch instead
      of taking the whole panel down. We render a minimal fallback —
      the panel is admin-only, so the "please refresh" message is the
      right UX trade-off (vs. an elaborate recovery flow).
    */}
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div style={{ padding: 24, fontFamily: 'system-ui' }}>
          <h1 style={{ marginTop: 0 }}>Something went wrong</h1>
          <p>The admin panel hit an unexpected error and has reported it.</p>
          <button type="button" onClick={resetError}>Try again</button>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

